export function hasPropertyCoordinates(property: { latitude?: unknown; longitude?: unknown }): boolean {
  const { latitude, longitude } = property;
  return typeof latitude === 'number' && Number.isFinite(latitude) && Math.abs(latitude) <= 90
    && typeof longitude === 'number' && Number.isFinite(longitude) && Math.abs(longitude) <= 180;
}

export function matchesProperty(property: Record<string, unknown>, query: string): boolean {
  const term = query.trim().toLocaleLowerCase();
  return ['property_name', 'address', 'city', 'state', 'zip_code', 'property_id']
    .some(key => String(property[key] ?? '').toLocaleLowerCase().includes(term));
}
